import { buildShopifyRedirectUrl } from './shopify-host-redirect';
import { navigateToShopifyWithGuard } from './shopify-redirect-guard';

export const redirectToShopifyAuth = (returnPath?: string) => {
  if (typeof window === 'undefined') {
    return;
  }

  const redirectUrl = buildShopifyRedirectUrl(returnPath || window.location.pathname, window.location.search);
  navigateToShopifyWithGuard({
    reason: 'auth',
    redirectUrl,
  });
};
